module.exports = __webpack_public_path__ + "img/bn.178e0b78.png";